import { FacilityService, MaintenanceFrequency, MaintenancePlanType } from "__generated__/graphql";
import { z } from "zod";

export const organizationInfoSchema = z.object({
  organization: z.string().min(1, "Organization Name is required"),
  roleInOrganization: z.string().min(1, "Role in organization is required"),
  industry: z.string().optional(),
});

export const contactInfoSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Please enter a valid phone number"),
});

export const maintenanceDetailsSchema = z.object({
  facilityLocation: z.string().min(1, "Facility location is required"),
  services: z.array(
    z.nativeEnum(FacilityService)
  ).min(1, "Select at least one service"),
  otherService: z.string().optional(),
  planType: z.nativeEnum(MaintenancePlanType),
  maintenanceFrequency: z
    .nativeEnum(MaintenanceFrequency)
    .optional(),
}).refine((data) => {
  if (data.planType === "ROUTINE") {
    return !!data.maintenanceFrequency;
  }
  return true;
}, {
  message: "Please select a maintenance frequency",
  path: ["maintenanceFrequency"],
});

export type OrganizationInfoFormData = z.infer<typeof organizationInfoSchema>;
export type MaintenanceContactInfoFormData = z.infer<typeof contactInfoSchema>;
export type MaintenanceDetailsFormData = z.infer<typeof maintenanceDetailsSchema>;


